import React, { useState } from 'react';
import CardMiddle from '../../../../layouts/Client/CardMiddleItems/index';
import * as ROUTES from '../../../../routes';
import SignInEmail from '../../../../pages/User-Client/Account/signInClient/Containers/SignInEmail';



const SignInClient = (props) => {

  return (
    <>
      <CardMiddle
        mainTitle='Iniciar sesión'
        desFooter='¿Aún no tienes cuenta?'
        footerTitle='Regístrate'
        linkTo={ROUTES.SIGN_UP_CLIENT}
        noCloseIcon
      >
        <SignInEmail noPush roleAuth='client' />
      </CardMiddle>
    </>
  );
}

export default SignInClient;